import {
  StopPlayer,
  PausePlayer,
  PlayPlayer,
  ReplayPlayer,
  MicrophoneIcon,
  UploadOutlineIcon,
} from "../AscIcons";
import styles from "./AscVoiceRecorder.module.scss";

import { IconButton } from "./AscVoiceRecorder.Button";

export function AscVoiceRecorderGuide({
  isRecording,
  isPaused,
  isFileTypeString,
  hasAudioSource,
  showRetryButton,
}: {
  isRecording: boolean;
  isPaused: boolean;
  isFileTypeString: boolean;
  hasAudioSource: boolean;
  showRetryButton: boolean;
}) {
  if (hasAudioSource && !isRecording) {
    if (isFileTypeString) {
      return (
        <div className={styles.audioGuide}>
          Click the{" "}
          <IconButton size="small" clickable={false}>
            {isPaused ? <PlayPlayer /> : <PausePlayer />}
          </IconButton>{" "}
          to {isPaused ? "play" : "pause"} recording
          {showRetryButton && (
            <>
              ,{" "}
              <IconButton size="small" clickable={false}>
                <ReplayPlayer />
              </IconButton>
              to rerecord
            </>
          )}
        </div>
      );
    } else {
      return (
        <div className={styles.audioGuide}>
          Click the{" "}
          <IconButton size="small" clickable={false}>
            <UploadOutlineIcon />
          </IconButton>{" "}
          button to upload recording,{" "}
          <IconButton size="small" clickable={false}>
            <ReplayPlayer />
          </IconButton>
          to rerecord and{" "}
          <IconButton size="small" clickable={false}>
            {isPaused ? <PlayPlayer /> : <PausePlayer />}
          </IconButton>
          to listen
        </div>
      );
    }
  } else {
    if (isRecording) {
      return (
        <div className={styles.audioGuide}>
          Click the{" "}
          <IconButton size="small" clickable={false}>
            {isPaused ? <PlayPlayer /> : <PausePlayer />}
          </IconButton>{" "}
          to {isPaused ? "play" : "pause"} recording,{" "}
          <IconButton size="small" clickable={false}>
            <StopPlayer />
          </IconButton>
          to finish
        </div>
      );
    } else {
      return (
        <div className={styles.audioGuide}>
          Click the{" "}
          <IconButton size="small" clickable={false}>
            <MicrophoneIcon />
          </IconButton>{" "}
          button to start recording
        </div>
      );
    }
  }
}
